export enum HealthStatusEnums {
  GATEWAY_QUANTITY = "Gateway Quantity",
  LUMINARY_QUANTITY = "Luminaire Quantity",
  SENSOR_QUANTITY = "Sensor Quantity",
  GATEWAY_FAILURE = "Gateway Failure",
  LIGHT_FAILURE = "Light Failure",
  SENSOR_FAILURE = "Sensor Failure",
  NETWORK_FAILURE = "Network Failure",
}

export enum EquipmentQuantityEnums {
  SENSOR_QUANTITY = 1,
  LUMINARY_QUANTITY = 2,
  GATEWAY_QUANTITY = 3,
}
